export const FORBIDDEN = 403
export const UNAUTHORIZED = 401
export const VIDEO_NOT_FOUND = 'Video not found'
